function asRecord(value: unknown): Record<string, unknown> {
  return value !== null && typeof value === 'object' ? (value as Record<string, unknown>) : {};
}

function formatPath(path: string) {
  return path
    .replace(/^instance\./, '')
    .replace(/promotions\[(\d+)\]/g, (_, index) => `Promotion ${Number(index) + 1}`)
    .split('.')
    .map((part) =>
      part
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .toLowerCase()
        .replace(/^./, (first) => first.toUpperCase()),
    )
    .join(' → ');
}

export function getPropertySaveError(error: unknown) {
  const source = asRecord(error);
  const message =
    source.status === 409
      ? 'The property has already been updated. Refresh the page and try saving again.'
      : typeof source.message === 'string' && source.message.trim()
        ? source.message
        : 'Unable to save the property. Please try again.';
  const errors = source.errors;
  const details = (Array.isArray(errors) ? errors : [errors]).flatMap((entry) => {
    if (typeof entry === 'string') return entry.trim() ? [entry] : [];
    const item = asRecord(entry);
    if (typeof item.message !== 'string' || !item.message.trim()) return [];
    return [typeof item.path === 'string' && item.path ? `${formatPath(item.path)}: ${item.message}` : item.message];
  });

  return { message, details: [...new Set(details)] };
}
